"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.classnames = exports.capitalizeFirstLetter = exports.ultraAbbreviateAddress = exports.abbreviateAddress = exports.abbreviate = void 0;
const clsx_1 = require("clsx");
const tailwind_merge_1 = require("tailwind-merge");
/**
 * @param str the string to abbreviate
 * @param keepLeft the number of chars to keep from the left
 * @param keepRight the number of chars to keep from the right
 * @returns an abbreviated string
 */
function abbreviate(str, keepLeft = 4, keepRight = 4) {
    if (!str)
        return str;
    if (str.length <= keepLeft + keepRight)
        return str;
    return str.substring(0, keepLeft) + '...' + str.substring(str.length - keepRight);
}
exports.abbreviate = abbreviate;
/**
 * @param str the string to abbreviate
 * @returns an abbreviated string, 0x + 4 chars + ... + 4 chars
 */
function abbreviateAddress(address) {
    return abbreviate(address, 6, 4);
}
exports.abbreviateAddress = abbreviateAddress;
/**
 * @param str the string to abbreviate
 * @returns an abbreviated string, 0x + ... + 4 chars
 * @dev used for ultra compact addresses
 */
function ultraAbbreviateAddress(address) {
    return abbreviate(address, 2, 4);
}
exports.ultraAbbreviateAddress = ultraAbbreviateAddress;
/**
 *
 * @param string string to capitalize just the first letter of
 * @returns the string with the first letter capitalized
 */
const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
};
exports.capitalizeFirstLetter = capitalizeFirstLetter;
/**
 * @param inputs the classes to merge for using with Tailwind/React
 * @returns a merged class string for use in Tailwind/React
 * @WARN This may not work if your tailwind project uses prefixing!!!
 */
function classnames(...inputs) {
    return (0, tailwind_merge_1.twMerge)((0, clsx_1.clsx)(inputs));
}
exports.classnames = classnames;
//# sourceMappingURL=string.js.map